import React from 'react';
import { motion } from 'framer-motion';
import { Mail, Github, Linkedin, MessageSquare, Send } from 'lucide-react';

const Contact = () => {
  const socialLinks = [
    { icon: <Github size={24} />, url: 'https://github.com/hm05', label: 'GitHub' },
    { icon: <Linkedin size={24} />, url: 'https://linkedin.com/in/harshmurjani', label: 'LinkedIn' },
    { icon: <Mail size={24} />, url: 'mailto:email@harshmurjani.dev', label: 'Email' }
  ];

  return (
    <section id="contact" className="py-24 bg-gray-50 dark:bg-[#1c1c1e] transition-colors duration-300">
      <div className="container mx-auto px-6 max-w-7xl">
        <div className="max-w-4xl mx-auto text-center">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
          >
            <h2 className="text-4xl md:text-5xl font-bold tracking-tight text-gray-900 dark:text-white mb-6 font-inter">
              Get In Touch
            </h2>
            <p className="text-xl text-gray-500 dark:text-gray-400 mb-12 font-inter max-w-2xl mx-auto">
              Whether you're looking for cybersecurity expertise, software development, or just want to connect—I'm always open to new opportunities.
            </p>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, scale: 0.95 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
            className="apple-card p-12 mb-12"
          >
            <div className="flex justify-center mb-8">
              <div className="p-4 rounded-3xl bg-blue-50 dark:bg-blue-900/20 text-blue-600 dark:text-blue-400">
                <MessageSquare size={40} />
              </div>
            </div>
            
            <h3 className="text-3xl font-bold text-gray-900 dark:text-white mb-4 font-inter">
              Ready to start a conversation?
            </h3>
            <p className="text-gray-600 dark:text-gray-300 mb-10 text-lg font-inter">
              The best way to reach me is via email. I usually respond within 24 hours.
            </p>

            <a 
              href="mailto:email@harshmurjani.dev"
              className="btn-primary px-10 py-5 inline-flex items-center gap-3 text-lg"
            >
              <Send size={20} /> email@harshmurjani.dev
            </a>
          </motion.div>

          <div className="flex justify-center gap-8">
            {socialLinks.map((link, idx) => (
              <motion.a
                key={link.label}
                href={link.url}
                target="_blank"
                rel="noreferrer"
                initial={{ opacity: 0, y: 10 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: idx * 0.1 }}
                className="text-gray-400 hover:text-blue-600 dark:hover:text-blue-400 transition-colors duration-300"
                aria-label={link.label}
              >
                {link.icon}
              </motion.a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
